import { Log, UserManager, WebStorageStateStore } from 'oidc-client';
import appLS from '../constants/local-storage';
import api from '../services/apiService'

export default function AuthService() {

  const settings = {
    authority: process.env.REACT_APP_AUTHORITY,
    client_id: process.env.REACT_APP_CLIENT_ID,
    redirect_uri: process.env.REACT_APP_REDIRECT_URI,
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI,
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI,
    response_type: process.env.REACT_APP_RESPONSE_TYPE,
    scope: process.env.REACT_APP_SCOPE,
    automaticSilentRenew: true,
    filterProtocolClaims: true,
    loadUserInfo: true,
    monitorSession: false,
    userStore: new WebStorageStateStore({ store: localStorage })
  };

  Log.logger = console;
  Log.level = Log.INFO;

  this.userManager = new UserManager(settings);

  this.getUser = () => {
    return this.userManager.getUser();
  }

  this.login = () => {
    return this.userManager.signinRedirect();
  }

  this.silentLogin = () => {
    return this.userManager.signinSilent();
  }

  this.logout = () => {
    /** since user selected language should 
     * persist in the storage, LS needs to 
     * be removed one by one */
    localStorage.removeItem('persist:root');
    localStorage.removeItem(appLS.user);
    localStorage.removeItem(appLS.companyKey);
    localStorage.removeItem(appLS.redirectUrl);
    return this.userManager.signoutRedirect();
  }

  this.userManager.events.addUserLoaded(user => {
    // setting the access token when renewing the token
    localStorage.setItem(appLS.user, JSON.stringify(user));
    api.setAccessToken();
  });

  this.userManager.events.addAccessTokenExpired(() => {
    this.logout();
  });
  
  this.userManager.events.addSilentRenewError(() => {
    this.logout();
  });
  
}